const config = [

  {
    field: 'supplierName',
    rowGroup: true,
    hide: true    
  },
  {
    colId: 'email',
    headerName: 'E-Mail',
    field: 'email',
    minWidth:50,
    suppressHeaderMenuButton: true,
    tooltipField: 'email',
    suppressMovable: true,
    cellStyle: { color: '#3498db' },
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    },
  },

];
export const autoGroupColumnDefForAdd =
{
    headerName: 'Supplier Name',
    field: 'name',
    minWidth: 200,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: true },
    suppressSizeToFit: true,
    suppressColumnsToolPanel: true,
    toolPanelClass: "ag-hide-toolpanel",
    width: 500,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    floatingFilter: true,
    filter: 'agSetColumnFilter',
    filterParams: {
      defaultOption: 'contains',
      caseSensitive: false
    },
    icons: {
      sortAscending: '<i class="fas fa-caret-up"></i>',
      sortDescending: '<i class="fas fa-caret-down"></i>'
    }
}



export default config;
